(function () {
  'use strict';

  // Copy the discount code from the top bar.
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-ezl-copy]');
    if (!button) return;
    var code = button.getAttribute('data-ezl-copy');
    var status = document.querySelector('[data-ezl-copy-status]');
    var done = function (text) { if (status) status.textContent = text; };
    if (!navigator.clipboard) { done('Your code is ' + code + '. Enter it at checkout.'); return; }
    navigator.clipboard.writeText(code).then(function () {
      button.classList.add('is-copied');
      done('Code ' + code + ' copied. Paste it at checkout.');
      setTimeout(function () { button.classList.remove('is-copied'); }, 2000);
    }).catch(function () {
      done('Your code is ' + code + '. Enter it at checkout.');
    });
  });

  // Help me choose: four questions, one recommendation.
  var quiz = document.querySelector('[data-ezl-quiz]');
  if (!quiz) return;
  var steps = Array.prototype.slice.call(quiz.querySelectorAll('[data-ezl-step]'));
  var results = Array.prototype.slice.call(quiz.querySelectorAll('[data-ezl-result]'));
  if (!steps.length || !results.length) return;
  var bar = quiz.querySelector('[data-ezl-bar]');
  var stepLabel = quiz.querySelector('[data-ezl-steplabel]');
  var percentLabel = quiz.querySelector('[data-ezl-pct]');
  var back = quiz.querySelector('[data-ezl-back]');
  var nav = quiz.querySelector('[data-ezl-nav]');
  var title = quiz.querySelector('[data-ezl-title]');
  var lead = quiz.querySelector('[data-ezl-lead]');
  var answers = [];
  var index = 0;

  function has(key) { return answers.indexOf(key) > -1; }

  function recommend() {
    if (has('use_outdoor') && has('range_long') && has('lift_help') && !has('fly_yes')) return 'scooter';
    if (has('fly_yes') || has('lift_solo') || has('use_travel')) return 'carbon';
    if (has('use_indoor') && has('range_short')) return 'lite';
    if (has('use_outdoor') && has('range_long')) return 'ergo';
    if (has('use_outdoor')) return 'roller';
    return 'lite';
  }

  function render(moveFocus) {
    var total = steps.length;
    var done = index >= total;
    var current = done ? total : index + 1;
    var percent = Math.round((current / total) * 100);
    var key = done ? recommend() : null;
    var shown = null;
    steps.forEach(function (step, i) { step.hidden = i !== index; });
    results.forEach(function (result) {
      result.hidden = result.getAttribute('data-ezl-result') !== key;
      if (!result.hidden) shown = result;
    });
    if (done && !shown) { shown = results[0]; shown.hidden = false; }
    if (bar) bar.style.width = percent + '%';
    if (stepLabel) stepLabel.textContent = 'Step ' + current + ' of ' + total;
    if (percentLabel) percentLabel.textContent = percent + '% complete';
    if (back) back.disabled = index === 0;
    if (nav) nav.hidden = done;
    if (title) title.textContent = title.getAttribute(done ? 'data-done' : 'data-start');
    if (lead) lead.textContent = lead.getAttribute(done ? 'data-done' : 'data-start');
    if (!moveFocus) return;
    var target = (done ? shown : steps[index]).querySelector('h2');
    if (target) { target.setAttribute('tabindex', '-1'); target.focus(); }
  }

  quiz.addEventListener('click', function (event) {
    var option = event.target.closest('[data-ezl-answer]');
    if (option) {
      answers.push(option.getAttribute('data-ezl-answer'));
      index += 1;
      render(true);
      return;
    }
    if (event.target.closest('[data-ezl-back]')) {
      if (index > 0) { answers.pop(); index -= 1; render(true); }
      return;
    }
    if (event.target.closest('[data-ezl-reset]')) {
      answers = [];
      index = 0;
      render(true);
    }
  });

  render(false);
})();
